import { Component } from '@angular/core';
import { API, TemplateStoreDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { UtilService } from 'src/app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { TagService } from '../../../services/tag.service';
import { DiscussionService } from '../../../services/discussion.service';
import { TableWrapperOptions } from '../../../services/global/global-interfaces';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'sb-page-content-editor-list',
  templateUrl: './content-editor-list.component.html',
  styleUrls: ['./content-editor-list.component.scss'],
  standalone: false,
})
export class ContentEditorListComponent {
  templateStoreDTOs: TemplateStoreDTO[];
  loading: boolean;
  debounceTimer: ReturnType<typeof setTimeout>;

  options: TableWrapperOptions;

  constructor(
    private api: API,
    public errorHandler: ErrorService,
    public util: UtilService,
    public translate: TranslateService,
    public tagService: TagService,
    public discussionService: DiscussionService,
    public permissionService: PermissionService
  ) {
    this.loading = true;
    this.debounceTimer = null;
    this.templateStoreDTOs = [];
  }

  requestDebounced(options?: TableWrapperOptions) {
    if (options) {
      this.options = options;
    }

    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    if (this.options?.pagination) {
      this.loading = true;
      this.api
        .mm_templating_store_TemplateStore_retrieveTemplateStore(
          {
            search: this.util.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
          },
          this.options.pagination
        )
        .subscribe({
          next: (template: TemplateStoreDTO[]) => {
            this.templateStoreDTOs = template;
            this.loading = false;
          },
          error: error => {
            this.errorHandler.errorHandler(error);
          },
        });
    }
  }
}
